<div class="container no-task">
    <img *ngIf="!darkTheme && !isInIframe" src="../../assets/images/notask.svg">
    <img *ngIf="darkTheme && !isInIframe" src="../../assets/images/whitelogo.png" width="80px">
    <h3 *ngIf="data && !order">Please wait while we load your tasks</h3>
    <h3 *ngIf="order">{{ orderMessage }}</h3>
    <div *ngIf="!sensor && !feeds && !data && !order && !allTask && !indices && !activityLog">
        <h3>You have no tasks </h3> 
        <span>Click on New to start tasking</span>
    </div>
    <div *ngIf="allTask && !data">
        <h3>You have no recent tasks </h3> 
        <span>Please click on All tab to view your previous tasks</span>
    </div>
    <div *ngIf="feeds">
        <h3>There are no feeds meeting the selection</h3> 
    </div>
    <div *ngIf="indices">
        <h3>There are no indices meeting the selection</h3> 
    </div>
    <div *ngIf="sensor">
        <h3>There are no sensors meeting the selection</h3> 
    </div>
    <div *ngIf="activityLog">
        <h3></h3> 
    </div>
    <div *ngIf="activityLog == 'no-data' || activityLog == 'filters-applied'">
        <h3>{{activityLog == 'no-data' ? 'No recent activity available.' : 'There are no activity logs found.'}}</h3>
        <span *ngIf="activityLog == 'no-data'">Try using the search filters to view previous activity.</span>
    </div>
</div>
